import React from "react";
import "../printStyles.css"

function DriverTrainingLog() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #DriverTrainingLog, #DriverTrainingLog * {
              visibility: visible;
            }
            #DriverTrainingLog {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="DriverTrainingLog" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Driver Training & Communications Log</h3>

        <form>
          {/* Managed By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="managedBy">
              Managed By (Name):
            </label>
            <input
              type="text"
              id="managedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter manager's name"
            />
          </div>

          {/* Date of Review */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="reviewDate">
              Date of Review:
            </label>
            <input
              type="date"
              id="reviewDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Driver Name */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverName">
              Driver Name:
            </label>
            <input
              type="text"
              id="driverName"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver name"
            />
          </div>

          {/* Last Training Logged */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="lastTrainingLogged">
              Last Training Logged:
            </label>
            <input
              type="text"
              id="lastTrainingLogged"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter last training logged"
            />
          </div>

          {/* New Training / Briefing */}
          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-4 text-gray-800">New Training/Briefing:</h4>
            <div className="flex flex-wrap items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">CPC</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">New Procedure</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Other</span>
              </label>
            </div>
          </div>

          {/* Manager Sign-Off */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="managerSignOff">
              Manager Sign-Off:
            </label>
            <input
              type="text"
              id="managerSignOff"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter manager's sign-off"
            />
          </div>

          {/* Notes Section */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Record details of any new training required or communications delivered..."
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()} // Will trigger the print dialog
              className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default DriverTrainingLog;